<template>
  <article class="layout-section -bg-shade -alt-top">
    <div class="layout-section__hgroup">
      <h3 class="layout-section__title -small -no-space">Groupe 3</h3>
      <p>Associations, groupes populaires, mouvements d’action sociale, organismes d’animation et de formation</p>
    </div>

    <section class="layout-grid">
      <div class="layout-grid__item card -smaller">
        <p>Contenu à venir</p>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: 'AboutMembersIndex2'
}
</script>
